import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'field',
    'nameSelect',
    'name',
    'id'
  ];

  static values = {
    hideFieldsIfBlank: { type: Boolean, default: false }
  };

  connect () {
    if (this.idTarget.value) {
      this._hideFields();
    }
  }

  // METHODS

  toggleFields (event) {
    const select = event.target;
    const option = select.options[select.selectedIndex];

    if (this._shouldShowFields(option.value)) {
      this._showFields();
    } else {
      this._hideFields();
    }

    this._toggleNameField(option);
    this._toggleId(option);
  }

  setNewOption () {
    if (this.hasNameTarget && this.nameTarget.value && !this.idTarget.value) {
      this.nameSelectTarget.tomselect.addOption({ value: '', text: this.nameTarget.value }, true);
      this.nameSelectTarget.tomselect.addItem('');
    }
  }

  _showFields () {
    const shouldEmptyFields = this.idTarget.value;

    this.fieldTargets.forEach((el) => {
      el.classList.remove('d-none');

      const elInputs = el.querySelectorAll('input,select,textarea');

      elInputs.forEach((input) => {
        input.disabled = false;

        if (shouldEmptyFields && !input.readOnly) {
          input.value = '';
          input.checked = false;
          input.dispatchEvent(new Event('clear')); // Needed for custom elements
        }
      });
    });
  }

  _hideFields () {
    this.fieldTargets.forEach((el) => {
      el.classList.add('d-none');
      el.querySelectorAll('input,select,textarea').forEach((input) => {
        input.disabled = true;
      });
    });
  }

  _toggleNameField (option) {
    if (!this.hasNameTarget) { return; }

    if (this._shouldShowFields(option.value)) {
      this.nameTarget.value = option.innerHTML;
      this.nameTarget.disabled = false;
    } else {
      this.nameTarget.disabled = true;
    }
  }

  _toggleId (option) {
    if (this._shouldShowFields(option.value)) {
      this.idTarget.disabled = true;
    } else {
      this.idTarget.value = option.value;
      this.idTarget.disabled = false;
    }
  }

  _shouldShowFields(value) {
    if (this.hideFieldsIfBlankValue && this.nameSelectTarget.tomselect.items.length == 0) {
      return false;
    } else {
      return value == '';
    }
  }
}
